// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"566e586a","250":"2a1dbf09","407":"e9c5b450","424":"88900929","436":"48451b33","453":"f394a27d","455":"2b9dbaca","501":"6168ae65","595":"ea34dc09","606":"519b41d6","691":"1a72b2af","821":"836fbc97","925":"474cf47d","969":"336e59e6"}[chunkId] + ".chunk.js";
};